var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"appear":"","css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter}},_vm._l((_vm.cards),function(card){return _c('div',{key:card.id,staticClass:"card"},[_c('p',[_vm._v(_vm._s(card.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }